/* eslint-disable react/no-unused-prop-types */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
  changeQueryParams,
  sendRequest,
  selectItemsIds,
  selectRequestState,
  selectPagination
} from 'mt-react-common/common/reducers/list/reducer';
import { selectUserId } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import qs from 'querystring';
import { t } from 'utils/translates';

import { selectItemById } from 'mt-react-common/common/reducers/objectCollection/reducer';

import PaginationBlock from '../../../Common/Pagination/PaginationBlock/index';

import MediumPreLoader from '../../../Common/PreLoaders/MediumPreLoader';
import TaskExecItem from '../_items/TaskExecItem';

const tasksExecsCollectionRN = 'tasksModule.collections.tasksExecsCollection';
const tasksExecsListByAuthUserRN = 'tasksModule.lists.tasksExecsListByAuthUser';

class TasksExecsListByAuthUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      queryParams: {
        page: 1
      },
      queryParamsStatic: props.queryParamsStatic
    };
    this.sendRequest();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.location !== prevProps.location &&
      this.props.location.pathname === prevProps.location.pathname &&
      this.props.location.hash === prevProps.location.hash
    ) {
      this.sendRequest();
    }
  }

  setQueryParams = queryParams => {
    this.state.queryParams = { ...this.state.queryParams, ...queryParams };
    this.props.changeQueryParams({
      ...this.state.queryParams,
      ...this.state.queryParamsStatic
    });
  };

  updateHistory = () => {
    this.context.router.history.push({
      pathname: this.props.location.pathname,
      search: `?${qs.stringify(this.state.queryParams)}`
    });
  };

  sendRequest = () => {
    this.setQueryParams(qs.parse(this.props.location.search.slice(1)));
    this.props.sendRequest();
  };

  render() {
    let comments = null;
    if (this.props.requestState.inProgress) {
      comments = <MediumPreLoader />;
    } else if (this.props.itemsIds.length > 0) {
      comments = (
        <React.Fragment>
          {this.props.itemsIds.map(itemId => (
            // eslint-disable-next-line react/no-array-index-key
            <TaskExecItem
              key={`taskExecLightItem${itemId}`}
              exec={this.props.selectItemById(itemId)}
              reducerName={this.tasksExecsListByAuthUserRN}
            />
          ))}
          <PaginationBlock
            paginationData={this.props.pagination}
            handlePageClick={pageNumber => {
              this.setQueryParams({ page: pageNumber });
              this.updateHistory();
            }}
          />
        </React.Fragment>
      );
    } else {
      comments = (
        <div className="alert alert-default text-center">
          <p>{t('Выполнения не найдены')} :-(</p>
        </div>
      );
    }

    return <React.Fragment>{comments}</React.Fragment>;
  }
}

TasksExecsListByAuthUser.defaultProps = {
  queryParamsStatic: {}
};

TasksExecsListByAuthUser.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  reducerName: PropTypes.string.isRequired,
  queryParamsStatic: PropTypes.shape({}),

  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired,
  itemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectItemById: PropTypes.func.isRequired,
  requestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired
  }).isRequired,
  pagination: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired,

  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
    hash: PropTypes.string.isRequired
  }).isRequired
};

TasksExecsListByAuthUser.contextTypes = {
  router: PropTypes.shape()
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state, tasksExecsListByAuthUserRN),
  pagination: selectPagination(state, tasksExecsListByAuthUserRN),
  itemsIds: selectItemsIds(state, tasksExecsListByAuthUserRN),
  selectItemById: id => selectItemById(state, tasksExecsCollectionRN, id),
  authUserId: selectUserId(state)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(tasksExecsListByAuthUserRN, queryParams)),
  sendRequest: () =>
    dispatch(sendRequest(tasksExecsListByAuthUserRN, props.taskId))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TasksExecsListByAuthUser)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/TasksExecsListByAuthUser/TasksExecsListByAuthUser.js